import React from 'react';
import { useTranslation } from 'react-i18next';
import { Heart, ChevronDown } from 'lucide-react';

/**
 * One flavour dropdown per free heart-shaped pizza (Omani Women's Day).
 * Uses a native <select> so phones show their own easy picker.
 */
const HeartFlavourPicker = ({ flavours, options, onChange }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  if (flavours.length === 0 || options.length === 0) return null;

  const nameOf = (item) => (lang === 'ar' && item.name_ar ? item.name_ar : item.name);

  return (
    <div className="w-full space-y-2">
      <p className="text-xs font-bold text-gray-600 uppercase tracking-wide">{t('womensDay.pickFlavour')}</p>
      {flavours.map((flavourId, index) => (
        <label key={index} className="flex items-center gap-2">
          <span className="flex items-center gap-1 text-sm font-bold text-red-700 whitespace-nowrap min-w-[2.25rem]">
            <Heart className="h-3.5 w-3.5 fill-red-600 text-red-600" />
            {flavours.length > 1 ? index + 1 : ''}
          </span>
          <span className="relative flex-1 min-w-0">
            <select
              value={flavourId}
              onChange={(e) => onChange(index, e.target.value)}
              aria-label={t('womensDay.flavourFor', { n: index + 1 })}
              className="w-full appearance-none bg-white border border-red-200 rounded-lg py-2.5 ps-3 pe-9 text-sm font-semibold text-gray-800 focus:outline-none focus:ring-2 focus:ring-red-300 truncate"
            >
              {options.map(option => (
                <option key={option.id} value={option.id}>{nameOf(option)}</option>
              ))}
            </select>
            <ChevronDown className="pointer-events-none absolute end-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
          </span>
        </label>
      ))}
    </div>
  );
};

export default HeartFlavourPicker;
